export enum StatusImport {
  done = 'done',
  stoppedWithError = 'stopped_with_error',
  inProgress = 'in_progress',
  init = 'init',
}
